import {
    DependenciesPayload,
    VehicleState,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getAccessToken } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getSubscriptionDetailedState(
    { subscriptionId }: { subscriptionId: string },
    { atlasSdk, appEventSdk }: DependenciesPayload,
): Promise<VehicleState> {
    try {
        const detailedState =
            await atlasSdk.domains.user.getSubscriptionDetailedState({
                request: { subscriptionId },
                accessToken: getAccessToken(),
            });
        appEventSdk.trackEvent({
            event: 'device-info',
            deviceInfo: {
                vin: detailedState.vehicleState?.vin,
                vid: detailedState.radioId,
                year: detailedState.vehicleState?.year,
                make: detailedState.vehicleState?.make,
                model: detailedState.vehicleState?.model,
            },
        });
        return {
            ...detailedState,
            deviceSource: 'ATLAS',
        };
    } catch (error: any) {
        // TODO: handle error scenarios like 404 vs a System error
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
